import script from "./HtmlConstructorBlockType.vue?vue&type=script&lang=ts&setup=true"
export * from "./HtmlConstructorBlockType.vue?vue&type=script&lang=ts&setup=true"

import "./HtmlConstructorBlockType.vue?vue&type=style&index=0&id=71d3f426&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d3f426"]])

export default __exports__